module.exports = __webpack_public_path__ + "static/media/abstract_blue.8cfea789.jpg";